import * as AppEventController from './app_event_controller.js?v=20260904f';
import * as AppController from './app_controller.js?v=20260904f';
import { AppRuntime } from './app_runtime.js?v=20260706d';
import * as ViewportController from '../viewport/viewport_controller.js?v=20260706d';
import * as AppOptionsController from './app_options_controller.js?v=20260904f';
import * as AuthController from '../user/auth_controller.js?v=20260904f';
import { configureSidebarUserCardActions } from '../sidebar/sidebar_user_card.js?v=20260806a';
import { registerCoreSidebarPanels } from '../sidebar/sidebar.js?v=20260904f';
import { initAppVersionBadge } from './app_version.js?v=20260706d';
import * as EditCommandController from '../interaction/edit_command_controller.js?v=20260903c';
import * as ClipboardController from '../selection/clipboard_controller.js?v=20260904f';
import * as InteractionController from '../interaction/interaction_controller.js?v=20260904f';
import * as SelectionController from '../selection/selection_controller.js?v=20260904f';
import * as SystemRegistry from '../registry/system_registry.js?v=20260904f';
import {
  current3DModalScenePreset,
  normalize3DModalFilters,
  requestCurrent3DFrame,
  reapply3DGroupVisibilityAfterSceneUpdate,
  render3D,
  set3DModalScenePreset,
  sync3DArticleDetail,
  update3DLighting
} from './three_lazy_runtime.js?v=20260904f';
import { ensureColorCatalogsForProject } from '../../../colors/color_catalog_registry.js?v=20260720a';
import { ProjectPersistenceService } from '../project/project_persistence_service.js?v=20260904f';
import { activeDrawingSheetPositionPrefix } from '../project/drawing_sheet_service.js?v=20260904c';
import { S } from './app_state.js?v=20260817c';

const APP_CLIPBOARD_PASTE_OFFSET_MM = 50;

function shouldHandleGlobalKeyDown(event) {
  return EditCommandController.shouldHandleGlobalKeyDown(event);
}

/**
 * Beschreibt read Stored App Options im Bereich Kernanwendung.
 *
 * Zweck:
 * - Unterstützt App-Orchestrierung, Speichern/Laden und globale Aktionen.
 * - Kapselt fachliche Hilfslogik im jeweiligen Modul, damit Aufrufer nicht die Moduldetails kennen müssen.
 * @returns {*} Berechnetes Ergebnis, gefundenes Objekt oder Statuswert; `null`/`false`, wenn keine gültige fachliche Lösung möglich ist.
 */
function readStoredAppOptions() {
  return AppOptionsController.readStoredAppOptions();
}

/**
 * Beschreibt persist App Options im Bereich Kernanwendung.
 *
 * Zweck:
 * - Unterstützt App-Orchestrierung, Speichern/Laden und globale Aktionen.
 * - Kapselt Speichern, Laden, Import oder Export von Projektdaten, damit Aufrufer nicht die Moduldetails kennen müssen.
 * Seiteneffekte: Beachtet Speichern, Laden, Import oder Export von Projektdaten; Änderungen erfolgen je nach Aufrufer am übergebenen Objekt oder globalen State.
 */
function persistAppOptions() {
  return AppOptionsController.persistAppOptions();
}

function ensureView3DInsulationOptions() {
  return AppOptionsController.ensureView3DInsulationOptions();
}

/**
 * Rendert die globalen Karten der linken Seitenleiste.
 *
 * Zweck:
 * - Projektkarte gehoert zum Projekt/Core und nicht zu einer Firma
 * - sorgt dafuer, dass ein Reload mit ArtStore dieselben globalen Karten zeigt wie Kern Studer
 *
 * Seiteneffekte: Schreibt in `#projectInfoPanel`. Die Panel-Funktion ersetzt
 * ihren Containerinhalt vollstaendig, daher entstehen beim Wechsel zwischen
 * Firmen oder bei mehrfachen Refreshes keine Duplikate.
 */
function renderGlobalSidebarPanels() {
  AppController.renderGlobalSidebarPanels();
}

/**
 * Hält den Hauptarbeitsbereich dauerhaft in der 2D-Draufsicht.
 *
 * 3D ist seit dem Modal-Umbau kein globaler View-State mehr. Diese zentrale
 * Synchronisation ersetzt die frühere View-Tab-Logik und darf den 3D-Canvas nur
 * anzeigen, wenn das Visualisierungsmodal offen ist.
 */
function syncPlanViewState() {
  AppController.syncPlanViewState();
}

/**
 * Beschreibt refresh im Bereich Kernanwendung.
 *
 * Zweck:
 * - Unterstützt App-Orchestrierung, Speichern/Laden und globale Aktionen.
 * - Kapselt fachliche Hilfslogik im jeweiligen Modul, damit Aufrufer nicht die Moduldetails kennen müssen.
 * @param {*} fit - Eingabewert für refresh.
 * Seiteneffekte: Beachtet fachliche Hilfslogik im jeweiligen Modul; Änderungen erfolgen je nach Aufrufer am übergebenen Objekt oder globalen State.
 */
function refresh(fit=false){
  AppController.refresh(fit);
}

function refreshChromeOnly(reason = '') {
  AppController.refreshChromeOnly(reason);
}

function renderPlanOnly(reason = '', options = {}) {
  AppController.renderPlanOnly(reason, options);
}

function requestPlanRender(reason = '', options = {}) {
  AppController.requestPlanRender(reason, options);
}

function startPlanNavigationLod(reason = 'nav') {
  AppController.startPlanNavigationLod(reason);
}

function requestAppRefresh(fit = false, reason = '') {
  AppController.requestAppRefresh(fit, reason);
}

function ensureCanvasLayout() {
  return ViewportController.ensureCanvasLayout();
}

/**
 * Beschreibt sync App Options Button im Bereich Kernanwendung.
 *
 * Zweck:
 * - Unterstützt App-Orchestrierung, Speichern/Laden und globale Aktionen.
 * - Kapselt Toolbar-, Werkzeug- und Bedienzustände, damit Aufrufer nicht die Moduldetails kennen müssen.
 * Seiteneffekte: Beachtet Toolbar-, Werkzeug- und Bedienzustände; Änderungen erfolgen je nach Aufrufer am übergebenen Objekt oder globalen State.
 */
function syncAppOptionsButton() {
  return AppOptionsController.syncAppOptionsButton();
}

/**
 * Rendert render App Options Panel im Bereich Kernanwendung.
 *
 * Zweck:
 * - Unterstützt App-Orchestrierung, Speichern/Laden und globale Aktionen.
 * - Kapselt Darstellung im Plan, Layer-Aufbau oder grafische Markierung, damit Aufrufer nicht die Moduldetails kennen müssen.
 * Seiteneffekte: Schreibt in DOM, SVG, Canvas oder Three.js-Strukturen und beeinflusst die sichtbare Darstellung.
 */
function renderAppOptionsPanel() {
  return AppOptionsController.renderAppOptionsPanel();
}

/**
 * Beschreibt wheel Zoom Factor im Bereich Kernanwendung.
 *
 * Zweck:
 * - Unterstützt App-Orchestrierung, Speichern/Laden und globale Aktionen.
 * - Kapselt fachliche Hilfslogik im jeweiligen Modul, damit Aufrufer nicht die Moduldetails kennen müssen.
 * @param {*} event - Browser-/Pointer-Event aus der Bedienoberfläche.
 * @returns {*} Berechnetes Ergebnis, gefundenes Objekt oder Statuswert; `null`/`false`, wenn keine gültige fachliche Lösung möglich ist.
 */
function wheelZoomFactor(event) {
  return InteractionController.wheelZoomFactor(event);
}

/**
 * Beschreibt hit Test Active Drawing System im Bereich Kernanwendung.
 *
 * Zweck:
 * - Unterstützt App-Orchestrierung, Speichern/Laden und globale Aktionen.
 * - Kapselt Darstellung im Plan, Layer-Aufbau oder grafische Markierung, damit Aufrufer nicht die Moduldetails kennen müssen.
 * @param {*} clientX - Eingabewert für hit Test Active Drawing System.
 * @param {*} clientY - Eingabewert für hit Test Active Drawing System.
 * @returns {*} Berechnetes Ergebnis, gefundenes Objekt oder Statuswert; `null`/`false`, wenn keine gültige fachliche Lösung möglich ist.
 */
function preferredHitSystemFromTarget(target) {
  return InteractionController.preferredHitSystemFromTarget(target);
}

function hitTestActiveDrawingSystem(clientX, clientY, targetOrPreferredSystem = null) {
  return InteractionController.hitTestActiveDrawingSystem(clientX, clientY, targetOrPreferredSystem);
}

/**
 * Entfernt clear Selection For Active System im Bereich Kernanwendung.
 *
 * Zweck:
 * - Unterstützt App-Orchestrierung, Speichern/Laden und globale Aktionen.
 * - Kapselt Auswahl, Trefferprüfung und Synchronisierung der UI-Selektion, damit Aufrufer nicht die Moduldetails kennen müssen.
 * Seiteneffekte: Aktualisiert die globale Auswahl und synchronisiert nachgelagerte UI-Zustände.
 */
function clearSelectionForActiveSystem() {
  return SelectionController.clearSelectionForActiveSystem();
}

/**
 * Prüft has Global Selection im Bereich Kernanwendung.
 *
 * Zweck:
 * - Unterstützt App-Orchestrierung, Speichern/Laden und globale Aktionen.
 * - Kapselt Auswahl, Trefferprüfung und Synchronisierung der UI-Selektion, damit Aufrufer nicht die Moduldetails kennen müssen.
 * @returns {*} Berechnetes Ergebnis, gefundenes Objekt oder Statuswert; `null`/`false`, wenn keine gültige fachliche Lösung möglich ist.
 */
function hasGlobalSelection() {
  return SelectionController.hasGlobalSelection();
}

/**
 * Entfernt clear Global Selection im Bereich Kernanwendung.
 *
 * Zweck:
 * - Unterstützt App-Orchestrierung, Speichern/Laden und globale Aktionen.
 * - Kapselt Auswahl, Trefferprüfung und Synchronisierung der UI-Selektion, damit Aufrufer nicht die Moduldetails kennen müssen.
 * @returns {*} Berechnetes Ergebnis, gefundenes Objekt oder Statuswert; `null`/`false`, wenn keine gültige fachliche Lösung möglich ist.
 */
function clearGlobalSelection() {
  return SelectionController.clearGlobalSelection();
}

function clearSelectionBeforeInsert() {
  return SelectionController.clearSelectionBeforeInsert();
}

function canMoveElement(element) {
  return SelectionController.canMoveElement(element);
}

function resetTransientInteractionState() {
  return SelectionController.resetTransientInteractionState();
}

function openLevelsPanelFromNeutralState() {
  return SelectionController.openLevelsPanelFromNeutralState();
}

function toggleLevelsTool() {
  return SelectionController.toggleLevelsTool();
}

function closeLevelsPanelForToolChange(options = {}) {
  return SelectionController.closeLevelsPanelForToolChange(options);
}

/**
 * Beschreibt start Pan im Bereich Kernanwendung.
 *
 * Zweck:
 * - Unterstützt App-Orchestrierung, Speichern/Laden und globale Aktionen.
 * - Kapselt fachliche Hilfslogik im jeweiligen Modul, damit Aufrufer nicht die Moduldetails kennen müssen.
 * @param {*} e - Eingabewert für start Pan.
 * Seiteneffekte: Beachtet fachliche Hilfslogik im jeweiligen Modul; Änderungen erfolgen je nach Aufrufer am übergebenen Objekt oder globalen State.
 */
function startPan(e){
  return ViewportController.startPan(e);
}

  /**
   * Stellt sicher ensure Multi Selection im Bereich Kernanwendung.
   *
   * Zweck:
   * - Unterstützt App-Orchestrierung, Speichern/Laden und globale Aktionen.
   * - Kapselt Auswahl, Trefferprüfung und Synchronisierung der UI-Selektion, damit Aufrufer nicht die Moduldetails kennen müssen.
   * @returns {*} Berechnetes Ergebnis, gefundenes Objekt oder Statuswert; `null`/`false`, wenn keine gültige fachliche Lösung möglich ist.
   */
  function ensureMultiSelection() {
    return SelectionController.ensureMultiSelection();
  }

  /**
   * Ermittelt resolved Multi Selection im Bereich Kernanwendung.
   *
   * Zweck:
   * - Unterstützt App-Orchestrierung, Speichern/Laden und globale Aktionen.
   * - Kapselt Auswahl, Trefferprüfung und Synchronisierung der UI-Selektion, damit Aufrufer nicht die Moduldetails kennen müssen.
   * @returns {*} Berechnetes Ergebnis, gefundenes Objekt oder Statuswert; `null`/`false`, wenn keine gültige fachliche Lösung möglich ist.
   */
  function resolvedMultiSelection() {
    return SelectionController.resolvedMultiSelection();
  }

  /**
   * Entfernt clear Multi Selection im Bereich Kernanwendung.
   *
   * Zweck:
   * - Unterstützt App-Orchestrierung, Speichern/Laden und globale Aktionen.
   * - Kapselt Auswahl, Trefferprüfung und Synchronisierung der UI-Selektion, damit Aufrufer nicht die Moduldetails kennen müssen.
   * Seiteneffekte: Aktualisiert die globale Auswahl und synchronisiert nachgelagerte UI-Zustände.
   */
  function clearMultiSelection() {
    return SelectionController.clearMultiSelection();
  }

  /**
   * Prüft has Multi Selection im Bereich Kernanwendung.
   *
   * Zweck:
   * - Unterstützt App-Orchestrierung, Speichern/Laden und globale Aktionen.
   * - Kapselt Auswahl, Trefferprüfung und Synchronisierung der UI-Selektion, damit Aufrufer nicht die Moduldetails kennen müssen.
   * @returns {*} Berechnetes Ergebnis, gefundenes Objekt oder Statuswert; `null`/`false`, wenn keine gültige fachliche Lösung möglich ist.
   */
  function hasMultiSelection() {
    return SelectionController.hasMultiSelection();
  }

  /**
   * Beschreibt multi Selection Contains Hit im Bereich Kernanwendung.
   *
   * Zweck:
   * - Unterstützt App-Orchestrierung, Speichern/Laden und globale Aktionen.
   * - Kapselt Auswahl, Trefferprüfung und Synchronisierung der UI-Selektion, damit Aufrufer nicht die Moduldetails kennen müssen.
   * @param {*} hit - Eingabewert für multi Selection Contains Hit.
   * @returns {*} Berechnetes Ergebnis, gefundenes Objekt oder Statuswert; `null`/`false`, wenn keine gültige fachliche Lösung möglich ist.
   */
  function multiSelectionContainsHit(hit) {
    return SelectionController.multiSelectionContainsHit(hit);
}

function startPlanBoxSelection(evt) {
  return SelectionController.startPlanBoxSelection(evt);
}

function finishPlanBoxSelection() {
  return SelectionController.finishPlanBoxSelection();
}

function normalizedWorldRect(a, b) {
  return SelectionController.normalizedWorldRect(a, b);
}

function planBoxSelectionMode(start, current) {
  return SelectionController.planBoxSelectionMode(start, current);
}

function collectObjectsInWorldRect(rect, mode = 'window') {
  return SelectionController.collectObjectsInWorldRect(rect, mode);
}

function obstacleBoundsMatchesRect(bounds, rect, mode = 'window') {
  return SelectionController.obstacleBoundsMatchesRect(bounds, rect, mode);
}

function normalizeBoxSelection(selection = {}) {
  return SelectionController.normalizeBoxSelection(selection);
}

function applyBoxSelection(selection) {
  return SelectionController.applyBoxSelection(selection);
}

function startMultiSelectionDrag(evt) {
  return SelectionController.startMultiSelectionDrag(evt);
}

function buildMultiSelectionMoveSnapshot(selection = SelectionController.resolvedMultiSelection()) {
  return SelectionController.buildMultiSelectionMoveSnapshot(selection);
}

function applyMultiSelectionMoveDelta(snapshot, dx, dz) {
  return SelectionController.applyMultiSelectionMoveDelta(snapshot, dx, dz);
}

function applyMultiSelectionDragPreview(snapshot, dx, dz) {
  return SelectionController.applyMultiSelectionDragPreview(snapshot, dx, dz);
}

function clearMultiSelectionDragPreview(snapshot) {
  return SelectionController.clearMultiSelectionDragPreview(snapshot);
}

function syncSelectionAfterMultiMove(snapshot, targetSelection = SelectionController.ensureMultiSelection()) {
  return SelectionController.syncSelectionAfterMultiMove(snapshot, targetSelection);
}

function drawPlanInteractionOverlay() {
  return SelectionController.drawPlanInteractionOverlay();
}

function drawPlanSelectionBoxOverlay(start, current, startScreen = null, currentScreen = null) {
  return SelectionController.drawPlanSelectionBoxOverlay(start, current, startScreen, currentScreen);
}

/**
 * Verarbeitet handle Undo Redo Key im Bereich Kernanwendung.
 *
 * Zweck:
 * - Unterstützt App-Orchestrierung, Speichern/Laden und globale Aktionen.
 * - Kapselt fachliche Hilfslogik im jeweiligen Modul, damit Aufrufer nicht die Moduldetails kennen müssen.
 * @param {*} e - Eingabewert für handle Undo Redo Key.
 * @returns {*} Berechnetes Ergebnis, gefundenes Objekt oder Statuswert; `null`/`false`, wenn keine gültige fachliche Lösung möglich ist.
 */
function handleUndoRedoKey(e) {
  return EditCommandController.handleUndoRedoKey(e);
}

/**
 * Verarbeitet handle Clipboard Key im Bereich Kernanwendung.
 *
 * Zweck:
 * - Unterstützt App-Orchestrierung, Speichern/Laden und globale Aktionen.
 * - Kapselt fachliche Hilfslogik im jeweiligen Modul, damit Aufrufer nicht die Moduldetails kennen müssen.
 * @param {*} e - Eingabewert für handle Clipboard Key.
 * @returns {*} Berechnetes Ergebnis, gefundenes Objekt oder Statuswert; `null`/`false`, wenn keine gültige fachliche Lösung möglich ist.
 */
function handleClipboardKey(e) {
  return ClipboardController.handleClipboardKey(e);
}

/**
 * Beschreibt copy Current Selection To Clipboard im Bereich Kernanwendung.
 *
 * Zweck:
 * - Unterstützt App-Orchestrierung, Speichern/Laden und globale Aktionen.
 * - Kapselt Auswahl, Trefferprüfung und Synchronisierung der UI-Selektion, damit Aufrufer nicht die Moduldetails kennen müssen.
 * @returns {*} Berechnetes Ergebnis, gefundenes Objekt oder Statuswert; `null`/`false`, wenn keine gültige fachliche Lösung möglich ist.
 */
function copyCurrentSelectionToClipboard() {
  return ClipboardController.copyCurrentSelectionToClipboard();
}

function buildCurrentMixedClipboardPayload(multiSelection = SelectionController.resolvedMultiSelection()) {
  return ClipboardController.buildCurrentMixedClipboardPayload(multiSelection);
}

function clipboardUniqueIds(values = []) {
  return ClipboardController.clipboardUniqueIds(values);
}

function clipboardPayloadObjectCount(payload = {}) {
  return ClipboardController.clipboardPayloadObjectCount(payload);
}

/**
 * Aktualisiert set App Clipboard im Bereich Kernanwendung.
 *
 * Zweck:
 * - Unterstützt App-Orchestrierung, Speichern/Laden und globale Aktionen.
 * - Kapselt Aktualisierung bestehender Daten und abhängiger Berechnungen, damit Aufrufer nicht die Moduldetails kennen müssen.
 * @param {*} payload - Eingabewert für set App Clipboard.
 * Seiteneffekte: Kann Projektstate, Auswahl, Snap-Verbindungen oder abhängige Layoutdaten verändern.
 */
function setAppClipboard(payload) {
  return ClipboardController.setAppClipboard(payload);
}

/**
 * Beschreibt paste From App Clipboard im Bereich Kernanwendung.
 *
 * Zweck:
 * - Unterstützt App-Orchestrierung, Speichern/Laden und globale Aktionen.
 * - Kapselt fachliche Hilfslogik im jeweiligen Modul, damit Aufrufer nicht die Moduldetails kennen müssen.
 * @returns {*} Berechnetes Ergebnis, gefundenes Objekt oder Statuswert; `null`/`false`, wenn keine gültige fachliche Lösung möglich ist.
 */
function pasteFromAppClipboard() {
  return ClipboardController.pasteFromAppClipboard();
}

function pasteFromSystemClipboard() {
  return ClipboardController.pasteFromSystemClipboard();
}

/**
 * Beschreibt paste Thermo Guard Modules im Bereich Kernanwendung.
 *
 * Zweck:
 * - Unterstützt App-Orchestrierung, Speichern/Laden und globale Aktionen.
 * - Kapselt fachliche Hilfslogik im jeweiligen Modul, damit Aufrufer nicht die Moduldetails kennen müssen.
 * @param {*} payload - Eingabewert für paste Mixed Objects.
 * @param {*} offset - Geometrischer Wert in Projektkoordinaten oder entlang einer lokalen Achse.
 * @returns {*} Berechnetes Ergebnis, gefundenes Objekt oder Statuswert; `null`/`false`, wenn keine gültige fachliche Lösung möglich ist.
 */
function pasteMixedObjects(payload, offset) {
  return ClipboardController.pasteMixedObjects(payload, offset);
}

function clipboardRemapId(sourceId, map, prefix) {
  return ClipboardController.clipboardRemapId(sourceId, map, prefix);
}

function pasteObstaclesFromClipboard(obstacles = [], offset = APP_CLIPBOARD_PASTE_OFFSET_MM) {
  return ClipboardController.pasteObstaclesFromClipboard(obstacles, offset);
}

function selectPastedClipboardObjects(ids = {}) {
  return ClipboardController.selectPastedClipboardObjects(ids);
}

  /**
   * Verarbeitet handle Delete Key im Bereich Kernanwendung.
   *
   * Zweck:
   * - Unterstützt App-Orchestrierung, Speichern/Laden und globale Aktionen.
   * - Kapselt Entfernen oder Zurücksetzen von State, DOM oder Auswahl, damit Aufrufer nicht die Moduldetails kennen müssen.
   * @param {*} e - Eingabewert für handle Delete Key.
   * @returns {*} Berechnetes Ergebnis, gefundenes Objekt oder Statuswert; `null`/`false`, wenn keine gültige fachliche Lösung möglich ist.
   */
  function handleDeleteKey(e) {
  return EditCommandController.handleDeleteKey(e);
}

  /**
   * Verarbeitet handle Arrow Nudge im Bereich Kernanwendung.
   *
   * Zweck:
   * - Unterstützt App-Orchestrierung, Speichern/Laden und globale Aktionen.
   * - Kapselt fachliche Hilfslogik im jeweiligen Modul, damit Aufrufer nicht die Moduldetails kennen müssen.
   * @param {*} e - Eingabewert für handle Arrow Nudge.
   * @returns {*} Berechnetes Ergebnis, gefundenes Objekt oder Statuswert; `null`/`false`, wenn keine gültige fachliche Lösung möglich ist.
   */
  function handleArrowNudge(e) {
  return EditCommandController.handleArrowNudge(e);
}

/**
 * Verarbeitet handle Escape Key im Bereich Kernanwendung.
 *
 * Zweck:
 * - Unterstützt App-Orchestrierung, Speichern/Laden und globale Aktionen.
 * - Kapselt fachliche Hilfslogik im jeweiligen Modul, damit Aufrufer nicht die Moduldetails kennen müssen.
 * @param {*} e - Eingabewert für handle Escape Key.
 * @returns {*} Berechnetes Ergebnis, gefundenes Objekt oder Statuswert; `null`/`false`, wenn keine gültige fachliche Lösung möglich ist.
 */
function handleEscapeKey(e) {
  return EditCommandController.handleEscapeKey(e);
}

/**
 * Prüft is Typing Target im Bereich Kernanwendung.
 *
 * Zweck:
 * - Unterstützt App-Orchestrierung, Speichern/Laden und globale Aktionen.
 * - Kapselt fachliche Hilfslogik im jeweiligen Modul, damit Aufrufer nicht die Moduldetails kennen müssen.
 * @param {*} target - Eingabewert für is Typing Target.
 * @returns {*} Berechnetes Ergebnis, gefundenes Objekt oder Statuswert; `null`/`false`, wenn keine gültige fachliche Lösung möglich ist.
 */
function isTypingTarget(target) {
  return EditCommandController.isTypingTarget(target);
}

/**
 * Beschreibt release Canvas Keyboard Focus im Bereich Kernanwendung.
 *
 * Zweck:
 * - Unterstützt App-Orchestrierung, Speichern/Laden und globale Aktionen.
 * - Kapselt fachliche Hilfslogik im jeweiligen Modul, damit Aufrufer nicht die Moduldetails kennen müssen.
 * Seiteneffekte: Beachtet fachliche Hilfslogik im jeweiligen Modul; Änderungen erfolgen je nach Aufrufer am übergebenen Objekt oder globalen State.
 */
function releaseCanvasKeyboardFocus() {
  return ViewportController.releaseCanvasKeyboardFocus();
}

let ksStudioAppInitialized = false;

async function initApp() {
  if (ksStudioAppInitialized) return;
  ksStudioAppInitialized = true;
  initAppVersionBadge();
  AppRuntime.configure({
    refresh: fit => AppController.refresh(fit),
    refreshChromeOnly: reason => AppController.refreshChromeOnly(reason),
    requestAppRefresh: (fit, reason) => AppController.requestAppRefresh(fit, reason),
    requestPlanRender: (reason, options) => AppController.requestPlanRender(reason, options),
    syncPlanViewState: () => AppController.syncPlanViewState(),
    drawPlanInteractionOverlay: () => SelectionController.drawPlanInteractionOverlay(),
    clearGlobalSelection: () => SelectionController.clearGlobalSelection(),
    clearMultiSelection: () => SelectionController.clearMultiSelection(),
    resetTransientInteractionState: () => SelectionController.resetTransientInteractionState(),
    toggleLevelsTool: () => SelectionController.toggleLevelsTool(),
    closeLevelsPanelForToolChange: options => SelectionController.closeLevelsPanelForToolChange(options),
    current3DModalScenePreset: view3d => current3DModalScenePreset(view3d || S.view3d),
    set3DModalScenePreset: presetId => set3DModalScenePreset(presetId),
    normalize3DModalFilters: view3d => normalize3DModalFilters(view3d || S.view3d),
    requestCurrent3DFrame: options => requestCurrent3DFrame(options),
    render3D: options => render3D(options),
    update3DLighting: options => update3DLighting(options),
    after3DSceneRendered: () => reapply3DGroupVisibilityAfterSceneUpdate(),
    after3DArticleSelected: selection => sync3DArticleDetail(selection),
    activeDrawingSheetPositionPrefix: (systemId, memberId) => (
      activeDrawingSheetPositionPrefix(systemId, memberId)
    )
  });
  SystemRegistry.configureRuntime({
    refresh: fit => AppController.refresh(fit),
    refreshChromeOnly: reason => AppController.refreshChromeOnly(reason),
    clearGlobalSelection: () => SelectionController.clearGlobalSelection()
  });
  AppOptionsController.configureRuntime({
    refresh: fit => AppController.refresh(fit),
    refreshChromeOnly: reason => AppController.refreshChromeOnly(reason)
  });
  AuthController.configureRuntime({
    refresh: fit => AppController.refresh(fit),
    refreshChromeOnly: reason => AppController.refreshChromeOnly(reason)
  });
  configureSidebarUserCardActions({
    requestLogin: () => AuthController.openLoginDialog(),
    requestUserProfile: (user, options) => AuthController.openProfileDialog(options)
  });
  registerCoreSidebarPanels();
  AuthController.initAuth();
  AppOptionsController.applyStoredAppOptions();
  try {
    await ensureColorCatalogsForProject(S.project);
    await SystemRegistry.ensureSystemsForProject(S.project, {
      activeSystemId: SystemRegistry.state.activeSystemId
    });
  } catch (error) {
    ksStudioAppInitialized = false;
    throw error;
  }
  SystemRegistry.renderShell();
  SystemRegistry.fitActiveCamera();
  AppEventController.bindAppEvents();
  AppController.refresh(false);
  await ProjectPersistenceService.autoOpenLastOrderIfEnabled({
    enabled: AppOptionsController.shouldAutoOpenLastOrder()
  }).catch(error => {
    console.warn('Letzter Auftrag konnte nicht automatisch geladen werden', error);
  });
}

export {
  APP_CLIPBOARD_PASTE_OFFSET_MM,
  shouldHandleGlobalKeyDown,
  readStoredAppOptions,
  persistAppOptions,
  ensureView3DInsulationOptions,
  renderGlobalSidebarPanels,
  syncPlanViewState,
  refresh,
  refreshChromeOnly,
  renderPlanOnly,
  requestPlanRender,
  startPlanNavigationLod,
  requestAppRefresh,
  ensureCanvasLayout,
  syncAppOptionsButton,
  renderAppOptionsPanel,
  wheelZoomFactor,
  preferredHitSystemFromTarget,
  hitTestActiveDrawingSystem,
  clearSelectionForActiveSystem,
  hasGlobalSelection,
  clearGlobalSelection,
  clearSelectionBeforeInsert,
  canMoveElement,
  resetTransientInteractionState,
  openLevelsPanelFromNeutralState,
  toggleLevelsTool,
  closeLevelsPanelForToolChange,
  startPan,
  ensureMultiSelection,
  resolvedMultiSelection,
  clearMultiSelection,
  hasMultiSelection,
  multiSelectionContainsHit,
  startPlanBoxSelection,
  finishPlanBoxSelection,
  normalizedWorldRect,
  planBoxSelectionMode,
  collectObjectsInWorldRect,
  obstacleBoundsMatchesRect,
  normalizeBoxSelection,
  applyBoxSelection,
  startMultiSelectionDrag,
  buildMultiSelectionMoveSnapshot,
  applyMultiSelectionMoveDelta,
  applyMultiSelectionDragPreview,
  clearMultiSelectionDragPreview,
  syncSelectionAfterMultiMove,
  drawPlanInteractionOverlay,
  drawPlanSelectionBoxOverlay,
  handleUndoRedoKey,
  handleClipboardKey,
  copyCurrentSelectionToClipboard,
  buildCurrentMixedClipboardPayload,
  clipboardUniqueIds,
  clipboardPayloadObjectCount,
  setAppClipboard,
  pasteFromAppClipboard,
  pasteFromSystemClipboard,
  pasteMixedObjects,
  clipboardRemapId,
  pasteObstaclesFromClipboard,
  selectPastedClipboardObjects,
  handleDeleteKey,
  handleArrowNudge,
  handleEscapeKey,
  isTypingTarget,
  releaseCanvasKeyboardFocus,
  initApp
};
